<template>
    <v-card class="panelBlock">
        <v-flex tag="h2" xs12 data-qe-id="My_Quick_Links_Title">
            {{ myToolsConstants.QUICK_LINKS.My_Quick_Links }}
            <v-btn
                @click="showQuickLinkDialog"
                class="more_option"
                v-if="showEditButton"
                data-qe-id="tools_editBtn"
                icon
            >
                <i class="fas fa-pencil-alt"></i>
            </v-btn>
        </v-flex>
        <my-quick-links></my-quick-links>
        <v-dialog absolute content-class="quick-links-popup" lazy max-width="1100" v-model="dialogState.dialogOpen">
            <v-card>
                <quick-link-dialog
                    :closeQuickLinkDialog="closeQuickLinkDialog"
                    :champsLeftPanel="false"
                    v-if="quickLinkDialogEnabled"
                ></quick-link-dialog>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeAction } from '../../../store/storeActions.constant';
import { myToolsConstants } from '../mytools.constant.js';
import MyQuickLinks from './MyQuickLinks';
import QuickLinkDialog from './QuickLinkDialog';
import { storeGetters } from '../../../store/storeGetters.constant';

export default {
    name: 'QuickLinks',
    data: () => ({
        myToolsConstants,
        dialogState: {
            isVisible: false,
            dialogOpen: false,
        },
    }),
    created() {
        if (
            !this.myQuickLinks ||
            this.myQuickLinks.length === 0 ||
            !this.categoryMaster ||
            this.categoryMaster.length === 0
        ) {
            this.getMyQuickLinks().then(() => {
                this.getCategoryLinks();
            });
        }
    },
    components: {
        MyQuickLinks,
        QuickLinkDialog,
    },
    methods: {
        ...mapActions({
            getCategoryLinks: `tools/${storeAction.getCategoryLinks}`,
            getMyQuickLinks: `tools/${storeAction.getMyQuickLinks}`,
        }),
        showQuickLinkDialog() {
            this.dialogState.dialogOpen = true;
        },
        closeQuickLinkDialog() {
            this.dialogState.dialogOpen = false;
        },
    },
    computed: {
        ...mapGetters({
            myQuickLinks: `tools/${storeGetters.myQuickLinks}`,
            categoryMaster: `tools/${storeGetters.categoryMaster}`,
        }),
        showEditButton() {
            return this.myQuickLinks && this.categoryMaster;
        },
        quickLinkDialogEnabled() {
            return this.dialogState.dialogOpen && this.myQuickLinks && this.categoryMaster;
        },
    },
};
</script>
